<div class="my-4 px-1">
    <div class="flex-align-center flex justify-between gap-10">
        <mat-slider
            [formControl]="formGroup.get(formItem)"
            [max]="values.length - 1"
            title="slider"
            aria-label="slider"
            color="primary"
            min="0"
            step="1">
            <input matSliderThumb />
        </mat-slider>

        <p class="w-16 whitespace-nowrap text-[16px] leading-5">
            {{ values[formGroup.get(formItem)?.value]?.KEY | translate }}
        </p>
    </div>
</div>
